<template>
	<md-dialog md-open-from="#custom" md-close-to="#custom" ref="contactDialog">
		<md-dialog-title>{{$t("admin.sendfeedback")}}</md-dialog-title>

		<md-dialog-content>
			{{$t("admin.feedbackinfo")}}
			
			<md-input-container v-if="type === 'contact'">
				<label>{{$t("name")}}</label>
				<md-textarea v-model="body.name"></md-textarea>
			</md-input-container>
			<md-input-container v-if="type === 'contact'">
				<label>{{$t("email")}}</label>
				<md-textarea v-model="body.email"></md-textarea>
			</md-input-container>
			<md-input-container v-if="type === 'contact'">
				<label>{{$t("admin.phonenumber")}}</label>
				<md-textarea v-model="body.phone"></md-textarea>
			</md-input-container>
			<md-input-container>
				<label>{{$t("admin.message")}}</label>
				<md-textarea v-model="body.message"></md-textarea>
			</md-input-container>
		</md-dialog-content>

		<md-dialog-actions>
			<md-button class="md-primary" @click.native="closeDialog()">Cancel</md-button>
			<md-button class="md-primary" @click.native="sendMessage()">Ok</md-button>
		</md-dialog-actions>
	</md-dialog>
</template>

<script>
	import Api from '../../generated'

	export default {
		data(){
			return{
				type: 'contact',
				body:{
					email: "", 
					message: this.message
				},
				dialog: this.$refs['contactDialog']
			}
		},
		methods: {
			onOpen() {
				console.log('Opened');
			},
			onClose(type) {
				console.log('Closed', type);
			},
			openDialog() {
				this.dialog.open();
			},
			closeDialog() {
				this.dialog.close();
			},
			sendMessage(){
				// TODO: require or use current user email?
				this.body['type'] = this.type;
				Api.ApiClient.instance.supportEmail(this.body, (error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						console.log(data)
						this.$bus.$emit('showToast','Köszönjük! Hamarosan felvesszük önnel a kapcsolatot.')
					}
					this.closeDialog();
				});
			}
		},
		created(){
			this.$bus.$on('showContact', (type) => {
				this.type = type;
				this.openDialog();
			});
		},
		mounted(){
			this.dialog = this.$refs['contactDialog']
			console.log(this.dialog);
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ContactDialog.vue?36d1b7aa